module.exports = __webpack_public_path__ + "img/icon.f66b0f3b.png";